// extracted by mini-css-extract-plugin
module.exports = {"highlightText":"FlightCardHighlight-module__highlightText___1Knx7"};